import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { BaseSeparateDataModal } from 'src/models/modals';
import { PlusSubscriptionStartGuideHelpIcon } from 'src/pages/StartGuide/plusSubscription/icons/HelpIcon';
import { HelpCard } from 'src/components/common/HelpCard';
import { UiModal } from 'src/components/UI/modal/UiModal';
import { HelpCardResponseType } from 'src/models/helpCard';

type Props = BaseSeparateDataModal<HelpCardResponseType | null> & {
  loading?: boolean;
};

export const HelpCardModal: FC<Props> = ({ data, onClose, loading }) => {
  const { t } = useTranslation();

  return (
    <UiModal
      header={
        <>
          <PlusSubscriptionStartGuideHelpIcon />
          {t('modals.helpModal.header')}
        </>
      }
      modalClassName="plussubscription-startguide-page-helper_modal"
      onHide={onClose}
      customFooter={() => null}
      loading={loading}
    >
      {data && <HelpCard data={data} />}
    </UiModal>
  );
};
